/** Espelha UserConsentsResponseContract (SiteCredentialsContracts/Consents). */

import { ConsentAnswerRequest } from "@/models/shared/consents/ConsentAuthorizationRequest";

export type UserConsentState = "Accepted" | "Refused";

/**
 * Espelha UpdateUserConsentsRequestContract. Distinto do ConsentAuthorizationRequest do gate de
 * login: aqui o ecra e multi-app, por isso a app alvo vai explicita no clientId.
 */
export type UpdateUserConsentsRequest = {
  clientId: string;
  consents: Array<ConsentAnswerRequest>;
};

export type UserConsentItem = {
  id: string;
  consentName?: string;
  displayText: string;
  description?: string;
  isMandatory: boolean;
  maskedValue?: string;
  displayOrder: number;
  state?: UserConsentState | null;
  decisionDate?: string | null;
};

export type AppConsents = {
  clientId: string;
  clientName: string;
  assetAlias?: string;
  flow?: string;
  items: Array<UserConsentItem>;
};

export type UserConsentsResponse = {
  nextStep: string;
  returnUrl?: string;
  from?: string;
  properties?: {
    apps?: Array<AppConsents>;
  };
};

/** O estado de um app deriva dos seus itens: basta um aceite para estar "Permitido". */
export function resolveAppState(app: AppConsents): UserConsentState {
  return app.items.some((item) => item.state === "Accepted") ? "Accepted" : "Refused";
}

/** Data da decisao mais recente do app, para a linha "Permitido em 16-03-2026". */
export function resolveAppDecisionDate(app: AppConsents): string | null {
  const dates = app.items
    .map((item) => item.decisionDate)
    .filter((date): date is string => !!date);

  if (dates.length === 0) return null;

  return dates.reduce((latest, date) => (date > latest ? date : latest));
}
